import httpRequest from '@/services/httpRequest.js'
export default ({
  namespaced: true,
  state: {
    isLoading: false,
    // ====================================================
    dailyPagination: {
      hasMore: true,
      page: 1,
      rows: 10,
    },
    dailyAttendance: {},
    dailyAttendanceList: [],
    dailyAttendanceSummary: {},
    // ====================================================
    leaveRequestPagination: {
      hasMore: true,
      page: 1,
      rows: 10,
    },
    leaveRequest: {},
    leaveRequestList: [],
    // ====================================================
    subjectPagination: {
      hasMore: true,
      page: 1,
      rows: 10,
    },
    subjectAttendance: {},
    subjectAttendanceList: [],
    subjectAttendanceSummary: {},
  },
  mutations: {
    SET_IS_LOADING(state, status) {
      state.isLoading = status
    },
    // ====================================================
    // Daily Attendance
    // ====================================================
    SET_HAS_MORE_DAILY(state, status) {
      state.dailyPagination.hasMore = status;
    },
    SET_PAGE_DAILY(state, page) {
      state.dailyPagination.page = page
    },
    RESET_PAGINATION_DAILY(state) {
      state.dailyPagination.page = 1;
      state.dailyPagination.hasMore = true;
      state.dailyAttendanceList = [];
    },
    SET_DAILY_ATTENDANCE(state, data) {
      state.dailyAttendance = data;
    },
    SET_DAILY_ATTENDANCE_LIST(state, data) {
      state.dailyAttendanceList = data;
    },
    APPEND_DAILY_ATTENDANCE_LIST(state, newData) {
      state.dailyAttendanceList = [
        ...state.dailyAttendanceList,
        ...newData
      ]
    },
    SET_DAILY_ATTENDANCE_SUMMARY(state, data) {
      state.dailyAttendanceSummary = data;
    },
    // ====================================================
    // Leave Request
    // ====================================================
    SET_HAS_MORE_LEAVE_REQUEST(state, status) {
      state.leaveRequestPagination.hasMore = status;
    },
    SET_PAGE_LEAVE_REQUEST(state, page) {
      state.leaveRequestPagination.page = page
    },
    RESET_PAGINATION_LEAVE_REQUEST(state) {
      state.leaveRequestPagination.page = 1;
      state.leaveRequestPagination.hasMore = true;
      state.leaveRequestList = [];
    },
    SET_LEAVE_REQUEST(state, data) {
      state.leaveRequest = data;
    },
    SET_LEAVE_REQUEST_LIST(state, data) {
      state.leaveRequestList = data;
    },
    APPEND_LEAVE_REQUEST_LIST(state, newData) {
      state.leaveRequestList = [
        ...state.leaveRequestList,
        ...newData
      ]
    },
    // ====================================================
    // Subject Attendance
    // ====================================================
    SET_HAS_MORE_SUBJECT(state, status) {
      state.subjectPagination.hasMore = status;
    },
    SET_PAGE_SUBJECT(state, page) {
      state.subjectPagination.page = page
    },
    RESET_PAGINATION_SUBJECT(state) {
      state.subjectPagination.page = 1;
      state.subjectPagination.hasMore = true;
      state.subjectAttendanceList = [];
    },
    SET_SUBJECT_ATTENDANCE(state, data) {
      state.subjectAttendance = data;
    },
    SET_SUBJECT_ATTENDANCE_LIST(state, data) {
      state.subjectAttendanceList = data;
    },
    APPEND_SUBJECT_ATTENDANCE_LIST(state, newData) {
      state.subjectAttendanceList = [
        ...state.subjectAttendanceList,
        ...newData
      ]
    },
    SET_SUBJECT_ATTENDANCE_SUMMARY(state, data) {
      state.subjectAttendanceSummary = data;
    },
  },
  actions: {
    async getDailyAttendanceList({ rootState, commit, state }, { isLoadMore = false, params = {} } = {}) {
      if (isLoadMore && !state.dailyPagination.hasMore) {
        return false;
      }

      const currentPage = isLoadMore ? state.dailyPagination.page + 1 : 1

      try {
        // Atur halaman dan loading state
        if (!isLoadMore) {
          commit('SET_IS_LOADING', true)
          commit('RESET_PAGINATION_DAILY') // Kembali ke page 1
        } else {
          commit('SET_PAGE_DAILY', currentPage) // Naik ke page berikutnya
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherdailyattendance`,
            method: 'GET',
            params: {
              ...params,
              page: currentPage,
              rows: state.dailyPagination.rows,
              all_teacher: false
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];
        // console.log("=== DAILY PAGINATION ===");
        // console.log("currentPage:", currentPage);
        // console.log("rows:", state.rows);
        // console.log("newItems:", newItems);
        // console.log("newItems.length:", newItems.length);
        // console.log("res.data:", res.data);

        // Cek apakah data sudah habis (jika yang didapat kurang dari batas rows)
        const hasMore = newItems.length >= state.dailyPagination.rows

        // console.log("hasMore:", hasMore);

        commit('SET_HAS_MORE_DAILY', hasMore)

        if (isLoadMore) {
          commit('APPEND_DAILY_ATTENDANCE_LIST', newItems);
        } else {
          commit('SET_DAILY_ATTENDANCE_LIST', newItems);
        }

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        // Jika load more gagal, kembalikan nomor halaman agar bisa dicoba lagi
        if (isLoadMore) {
          commit('SET_PAGE_DAILY', state.dailyPagination.page - 1)
        }
      } finally {
        if (!isLoadMore) {
          commit('SET_IS_LOADING', false)
        }
      }

      return false;
    },
    async getDailyAttendanceListNoPage({ rootState, commit, state }, params = {}) {

      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherdailyattendance`,
            method: 'GET',
            params: {
              ...params,
              page: 1,
              rows: 100,
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];

        commit('SET_DAILY_ATTENDANCE_LIST', newItems);

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
      } finally {
        commit('SET_IS_LOADING', false)
      }

      return false;
    },
    async getDailyAttendanceSummary({ rootState, commit, state }, params = {}) {

      try {
        // commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherdailyattendance/summary`,
            method: 'GET',
            params: {
              ...params,
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItem = res.data?.results || res.data || [];
        commit('SET_DAILY_ATTENDANCE_SUMMARY', newItem);

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
      } finally {
        // commit('SET_IS_LOADING', false)
      }

      return false;
    },
    async getleaveReqList({ rootState, commit, state }, { isLoadMore = false, params = {} } = {}) {
      if (isLoadMore && !state.leaveRequestPagination.hasMore) {
        return false;
      }

      const currentPage = isLoadMore ? state.leaveRequestPagination.page + 1 : 1

      try {
        // Atur halaman dan loading state
        if (!isLoadMore) {
          commit('SET_IS_LOADING', true)
          commit('RESET_PAGINATION_LEAVE_REQUEST') // Kembali ke page 1
        } else {
          commit('SET_PAGE_LEAVE_REQUEST', currentPage) // Naik ke page berikutnya
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherleaverequest`,
            method: 'GET',
            params: {
              ...params,
              page: currentPage,
              rows: state.leaveRequestPagination.rows,
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];
        // console.log("=== LEAVE REQ PAGINATION ===");
        // console.log("currentPage:", currentPage);
        // console.log("rows:", state.rows);
        // console.log("newItems:", newItems);
        // console.log("newItems.length:", newItems.length);
        // console.log("res.data:", res.data);

        // Cek apakah data sudah habis (jika yang didapat kurang dari batas rows)
        const hasMore = newItems.length >= state.leaveRequestPagination.rows

        // console.log("hasMore:", hasMore);

        commit('SET_HAS_MORE_LEAVE_REQUEST', hasMore)

        if (isLoadMore) {
          commit('APPEND_LEAVE_REQUEST_LIST', newItems);
        } else {
          commit('SET_LEAVE_REQUEST_LIST', newItems);
        }

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        // Jika load more gagal, kembalikan nomor halaman agar bisa dicoba lagi
        if (isLoadMore) {
          commit('SET_PAGE_LEAVE_REQUEST', state.leaveRequestPagination.page - 1)
        }
      } finally {
        if (!isLoadMore) {
          commit('SET_IS_LOADING', false)
        }
      }

      return false;
    },
    async addLeaveRequest({ rootState, commit }, data) {
      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherleaverequest`,
            method: 'POST',
            data: data
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (![200, 201].includes(res.status)) {
          return { status: false, data: res.data }
        }
        return { status: true, data: res.data }

      } catch (error) {
        //console.log('Gagal tambah data : ', error)
        return {
          status: false,
          data: error,
        };
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },
    async updateDailyAttendance({ rootState, commit }, { id, data = {} } = {}) {
      try {

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherdailyattendance/${id}`,
            method: 'PATCH',
            data: data
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (![200, 201].includes(res.status)) {
          return { status: false, data: res.data }
        }
        return { status: true, data: res.data }

      } catch (error) {
        //console.log('Gagal edit data : ', error)
        return {
          status: false,
          data: error,
        };
      }
    },
    async revokeLeaveRequest({ rootState, commit }, id) {
      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherleaverequest${id}/revoke`,
            method: 'GET',
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (![200, 201].includes(res.status)) {
          return false
        }
        return true

      } catch (error) {
        //console.log('Gagal tambah data : ', error)
        return false
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },
    async getSubjectAttendance({ rootState, commit, state }, { isLoadMore = false, params = {} } = {}) {
      if (isLoadMore && !state.subjectPagination.hasMore) {
        return false;
      }

      const currentPage = isLoadMore ? state.subjectPagination.page + 1 : 1

      try {
        // Atur halaman dan loading state
        if (!isLoadMore) {
          commit('SET_IS_LOADING', true)
          commit('RESET_PAGINATION_SUBJECT') // Kembali ke page 1
        } else {
          commit('SET_PAGE_SUBJECT', currentPage) // Naik ke page berikutnya
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teachersubjectattendance`,
            method: 'GET',
            params: {
              ...params,
              page: currentPage,
              rows: state.subjectPagination.rows,
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];

        // Cek apakah data sudah habis (jika yang didapat kurang dari batas rows)
        const hasMore = newItems.length >= state.subjectPagination.rows

        // console.log("hasMore:", hasMore);

        commit('SET_HAS_MORE_SUBJECT', hasMore)

        if (isLoadMore) {
          commit('APPEND_SUBJECT_ATTENDANCE_LIST', newItems);
        } else {
          commit('SET_SUBJECT_ATTENDANCE_LIST', newItems);
        }

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        // Jika load more gagal, kembalikan nomor halaman agar bisa dicoba lagi
        if (isLoadMore) {
          commit('SET_PAGE_SUBJECT', state.subjectPagination.page - 1)
        }
      } finally {
        if (!isLoadMore) {
          commit('SET_IS_LOADING', false)
        }
      }

      return false;
    },
    async getSubjectAttendanceNoPage({ rootState, commit, state }, params = {}) {

      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teachersubjectattendance`,
            method: 'GET',
            params: {
              ...params,
              page: 1,
              rows: 100,
              all_teacher: false
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];

        commit('SET_SUBJECT_ATTENDANCE_LIST', newItems);

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
      } finally {
        commit('SET_IS_LOADING', false)
      }

      return false;
    },
  }
})